export default "__VITE_ASSET__8eZ4N4WJ__"